
import React from 'react';
import ServiceCard from "@/components/ServiceCard";
import { 
  PiggyBank, 
  Briefcase, 
  Compass
} from "lucide-react";

const UnifiedServicesSection = () => {
  return (
    <section className="section-spacing bg-warm-white" id="services">
      <div className="container">
        <div className="max-w-3xl mx-auto mb-12">
          <h2 className="text-center mb-6 font-heading text-deep-sage animate-fade-in">
            Zwei Welten – ein Ansatz
          </h2>
          <p className="text-soft-charcoal text-center text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '100ms' }}>
            Ob privat oder beruflich: Im Mittelpunkt steht immer der Mensch. 
            Mein integrativer Ansatz verbindet wirtschaftlichen Weitblick mit menschlicher Tiefe.
          </p>
        </div>

        {/* Two Worlds Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          
          {/* Welt 1: Privatpersonen (Du) */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="h-1 w-8 bg-primary/40 rounded-full"></div>
              <h3 className="text-lg font-heading font-semibold text-deep-sage" id="privatpersonen">
                Für Privatpersonen
              </h3>
            </div>
            <div className="space-y-6">
              <ServiceCard
                title="Finanzcoaching"
                description="Entwickle ein gesundes Verhältnis zu Geld und triff nachhaltige Finanzentscheidungen. Individuell, vertraulich, ohne Verkaufsinteressen."
                icon={<PiggyBank className="h-5 w-5" />}
                link="/coaching"
                delay={0}
                benefits={[
                  "Psychologie des Geldes verstehen",
                  "Nachhaltige Finanzstrategien",
                  "Finanzielle Selbstbestimmung"
                ]}
              />
              <ServiceCard
                title="Outdoor Coaching am Rothsee"
                description="Coaching in der Natur bei Nürnberg. Walk & Talk für neue Perspektiven – raus aus gewohnten Denkmustern."
                icon={<Compass className="h-5 w-5" />}
                link="/outdoor-coaching"
                delay={150}
                benefits={[
                  "Coaching in natürlicher Umgebung",
                  "Ganzheitliche Aktivierung",
                  "Intuition und Ratio verbinden"
                ]}
              />
            </div>
          </div>

          {/* Welt 2: Business (Sie) */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="h-1 w-8 bg-accent/60 rounded-full"></div>
              <h3 className="text-lg font-heading font-semibold text-deep-sage" id="unternehmen">
                Für Unternehmen
              </h3>
            </div>
            <div className="relative">
              {/* Highlighted card */}
              <ServiceCard
                title="Executive Coaching & Katalysator-Führung"
                description="Führungskräfte-Entwicklung mit emotionaler Intelligenz. Strategische Begleitung für Entscheider, die anders führen wollen."
                icon={<Briefcase className="h-5 w-5" />}
                link="/consulting"
                delay={0}
                benefits={[
                  "Katalysator-Führung implementieren",
                  "Empathische Führungskultur aufbauen",
                  "Mitarbeiterbindung nachhaltig stärken"
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default UnifiedServicesSection;
